import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

interface AiData {
  total_calls: number;
  calls_today: number;
  success_rate: number | null;
  estimated_cost_today: number | null;
  avg_duration_by_function: Record<string, number> | null;
  tokens_by_model: Record<
    string,
    {
      total_calls: number;
      total_input_tokens: number;
      total_output_tokens: number;
      total_tokens: number;
      avg_tokens_per_call: number;
    }
  > | null;
  estimated_cost_by_model: Record<string, number> | null;
  cost_by_prompt: Record<string, number> | null;
  recent_failures: Array<{
    function_name: string;
    model: string;
    error_message: string | null;
    created_at: string;
  }> | null;
}

type DataHookResult<T> = {
  data: T | undefined;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => Promise<unknown>;
};

export function useAiDashboard(): DataHookResult<AiData> {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["ai-dashboard"],
    queryFn: async () => {
      const { data: result, error: rpcError } = await supabase.rpc(
        "get_ai_dashboard"
      );
      if (rpcError) throw new Error(rpcError.message);
      return result as unknown as AiData;
    },
  });

  return {
    data,
    isLoading,
    isError,
    error: error instanceof Error ? error : null,
    refetch: async () => {
      await refetch();
    },
  };
}

export function invalidateAiDashboard() {
  // This would be called from the query client in a real implementation
  // For now, it's a placeholder for cache invalidation pattern
}
